import { ReactElement } from 'react';
import { Stack, Typography } from '@mui/material';

import MultipleLinearProgresBar from '~components/MultipleLinearProgresBar';
import { toAbsoluteUrl } from '~utils/assetsHelpers';

// eslint-disable-next-line max-len
import { DashboardVariantV2CarrierHeaderLogoImg } from '../../../../../../Header/SubComponents/styles';

import { useDashboardVariantV2CarrierContentCollectTrackingContext } from '../Context';
import DashboardVariantV2CarrierContentCollectTabTrackingSelectionTabs from './Tabs';

import { DashboardVariantV2CarrierContentCollectTabTrackingSelectionContainer } from './styles';

const DashboardVariantV2CarrierContentCollectTabTrackingSelection =
  (): ReactElement => {
    const {
      tabsData: { data: tabsData },
    } = useDashboardVariantV2CarrierContentCollectTrackingContext();

    return (
      <DashboardVariantV2CarrierContentCollectTabTrackingSelectionContainer>
        <Stack spacing={1.5}>
          <Typography variant="h5">
            <strong>{tabsData?.totalCollected ?? 0}</strong> Pedidos en colecta
          </Typography>

          <MultipleLinearProgresBar
            items={[
              {
                label: 'Envíos estándar',
                value: tabsData?.totalCollectedNoFlex ?? 0,
                color: '#5618B6',
                customDot: (
                  <DashboardVariantV2CarrierHeaderLogoImg
                    src={toAbsoluteUrl('/logo_minimal.svg')}
                    alt="Routix Icon"
                  />
                ),
              },
              {
                label: 'Envíos Flex',
                value: tabsData?.totalCollectedFlex ?? 0,
                color: '#FFEB00',
                customDot: (
                  <DashboardVariantV2CarrierHeaderLogoImg
                    src={toAbsoluteUrl('/images/icon_source_mp@2x.png')}
                    alt="MercadoPago Icon"
                  />
                ),
              },
            ]}
            size="medium"
            showTotal={false}
            showLegend
          />
        </Stack>

        <DashboardVariantV2CarrierContentCollectTabTrackingSelectionTabs />
      </DashboardVariantV2CarrierContentCollectTabTrackingSelectionContainer>
    );
  };

export default DashboardVariantV2CarrierContentCollectTabTrackingSelection;
